var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"unit-number-input"},[_c('el-input',_vm._b({attrs:{"type":"number","min":_vm.$attrs.min || '-1000',"max":_vm.$attrs.max || '1000',"step":_vm.$attrs.step || '0.1'},on:{"change":_vm.emitInput},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'el-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }